export const works: Record<string, { title: string; img: string }> = {
  '1': { title: 'Test work', img: '1.png' },
  '2': { title: 'Work 2', img: '2.png' },
  '3': { title: 'Test', img: '3.png' },
}
